import axios from 'axios';
import jwtDecode from 'jwt-decode'

export function auth(username, pwd){
    
    return axios({
      method: 'post',
      url: process.env.REACT_APP_URL_AUTH,
      headers: {        
        "content-type": "application/json",
      },
      "data": {
        "username": username,
        "password": pwd,       
      }
    })
    .then((res) => {      
      return res
    },
    (error) => {            
      return error
      }
    )  
}

export function isAuthenticaded(){       
  const token = localStorage.getItem(process.env.REACT_APP_COOKIE_NAME)
  return token?true:false
}

export function account(){      
  let decode = jwtDecode(localStorage.getItem(process.env.REACT_APP_COOKIE_NAME))    
  return JSON.parse(decode.sub)
}
  
export function info(){            
  return JSON.parse(localStorage.getItem(process.env.REACT_APP_COOKIE_INFO))
}
  
export function generateCookieInfo(data){         
  localStorage.setItem(process.env.REACT_APP_COOKIE_INFO, JSON.stringify(data));
}

export function token(){      
  return localStorage.getItem(process.env.REACT_APP_COOKIE_NAME);
}
  
export function generateCookieToken(token){    
  localStorage.setItem(process.env.REACT_APP_COOKIE_NAME, token);
}

export function clearLocalStorage(){  
  localStorage.removeItem(process.env.REACT_APP_COOKIE_NAME)
  localStorage.removeItem(process.env.REACT_APP_COOKIE_INFO)
}